<script setup lang="ts">
import DatePickerField from '@/components/Fields/DatePickerField.vue'
import { StackLayout } from '@/components/Layouts'
import type { AdvancedDetectionFilters, DetectionFilters } from '@/types/filters/DetectionFilters'
import type { DetectionModel } from '@/types/models/DetectionModel'
import moment from 'moment'
import DebouncedNumberInputField from '../../components/Fields/DebouncedNumberInputField.vue'

type Props = {
    filters: Partial<AdvancedDetectionFilters & DetectionFilters>
}

defineProps<Props>()
type Emits = {
    (e: 'change', value: Partial<AdvancedDetectionFilters & DetectionModel>): void
}
defineEmits<Emits>()
</script>

<template>
    <StackLayout direction="column" :gap="12" class="full-width">
        <StackLayout :gap="8" class="full-width advanced-datepicker" isResponsiveSmallScreen>
            <DatePickerField
                :label="$t('detection.filters.startDate')"
                :modelValue="filters.start_at ? moment(filters.start_at).toDate() : undefined"
                @change="
                    $emit('change', {
                        start_at: $event
                            ? moment(
                                  moment($event).startOf('d').format(moment.defaultFormatUtc)
                              ).toDate()
                            : undefined
                    })
                "
                :maxDate="
                    filters.end_at
                        ? moment(filters.end_at).startOf('d').toDate()
                        : moment().startOf('d').toDate()
                "
                clearable
                class="full-width" />
            <DatePickerField
                :label="$t('detection.filters.endDate')"
                :modelValue="filters.end_at ? moment(filters.end_at).toDate() : undefined"
                @change="
                    $emit('change', {
                        end_at: $event
                            ? moment(
                                  moment($event).endOf('d').format(moment.defaultFormatUtc)
                              ).toDate()
                            : undefined
                    })
                "
                :maxDate="moment().endOf('d').toDate()"
                clearable
                class="full-width" />
        </StackLayout>
        <StackLayout :gap="8" class="full-width" isResponsiveSmallScreen>
            <DebouncedNumberInputField
                :label="$t('detection.filters.timerId')"
                :modelValue="filters.timer_filter"
                :prefix="$t('unit.number')"
                @change="$emit('change', { timer_filter: $event })"
                class="full-width" />
            <DebouncedNumberInputField
                :label="$t('detection.filters.eventId')"
                :modelValue="filters.event_filter"
                @change="$emit('change', { event_filter: $event })"
                :prefix="$t('unit.number')"
                :disabled="!filters.timer_filter"
                class="full-width" />
        </StackLayout>
    </StackLayout>
</template>

<style scoped lang="scss">
.advanced-datepicker {
    & :deep(.dropdown-menu) {
        @media screen and (max-width: 1023px) {
            margin-top: 7vh;
        }
        display: flex;
        flex-direction: column;
        justify-content: center;
        max-height: unset;
    }
}
</style>
